// extracted by mini-css-extract-plugin
module.exports = {"root":"PromotionTrending_root__DoDNW","text":"PromotionTrending_text__Alru8"};